<template>
<div>
  <el-checkbox
    :value="tbForm[key]"
    :true-label="trueLabel"
    :false-label="falseLabel"
    @change="onChange"
  ><span v-html="label"></span></el-checkbox>
  <span
    v-if="key === 'deliveryTimeSetBySku'">
    <el-tooltip
      class="item"
      effect="dark"
      placement="top">
      <div slot="content">该设置需要您的店铺及类目有sku预<br/>售权限，若无权限则设置不生效</div>
      <i style="margin-left: 5px;margin-bottom: 2px;" class="el-icon-warning" />
    </el-tooltip>
    <span class="tips ft-12">（不勾选，代表当前款所有规格都是同一发货时间；勾选后，可在<span style="color:#606266;font-weight:bold;">商品明细</span>中，按规格设置不同发货时间）</span>
  </span>
  
</div>
</template>

<script>
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      isHasOptionsComp: true,
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    label() {
      return this.props.dataSource.label || '未知'
    },
    trueLabel() {
      return (this.props.dataSource.options || []).find(item => item.displayName === '是')?.value || '1'
    },
    falseLabel() {
      return (this.props.dataSource.options || []).find(item => item.displayName === '否')?.value || '0'
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTbForm(newFormFields)
    },
  },
};
</script>
